// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-descriptions-item-label[data-v-14580596] {\n  font-weight: 500;\n}\n.ant-descriptions-item-content[data-v-14580596] {\n  word-break: break-all;\n}\n", ""]);
// Exports
module.exports = exports;
